
<template>
    
        <mars-view v-if="regulations" class="lawitems"><mars-view v-for="(item, i) in regulations" :key="i" class="law-item" :data-index="i" :class="{nopadding: i === 0}" @click.native="regulationsItemClick(item, i)"><mars-view class="article-title"><mars-rich-text :nodes="(item.name)"></mars-rich-text></mars-view><mars-view class="decs"><mars-text class="time">
                {{ item.effective_level }} | {{ item.release_department }} | {{ item.release_date }}发布 | {{ item.effective_date }}实施</mars-text><mars-text v-if="item.timeliness_type !== '-1'" class="tag" :class="item.dynamicTag">{{ item.timeliness }}</mars-text></mars-view><mars-view class="article"><mars-view class="items"><mars-view class="item c-line-clamp2">
                    {{ item.summary }}
                </mars-view></mars-view></mars-view></mars-view><mars-view v-if="regulations && regulations.length !== 0" class="lawitems-tip">
        已显示全部内容
    </mars-view><no-content v-else :font-size="'13px'" :l-height="'175px'" txt="“抱歉，没有找到相关内容”" txt-style="color: #999;font-size: 14px;"></no-content></mars-view>
    
</template>

<script>
import { nav } from '../../../static/utils/navigate';
import NoContent from "../../common/noContent.vue";
import { ubcClickInit } from '../../../static/utils/ubcMethods.js';
export default {
  components: {
    'no-content': NoContent
  },
  props: {
    regulations: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    regulationsItemClick(item, i) {
      ubcClickInit({
        page: 'regulations',
        value: 'regulations-list-clk',
        ext: {
          id: item.lawid,
          index: i
        }
      });
      nav({
        url: item.path
      });
    }
  }
};
</script>

<style scoped>
 /deep/ em {
  color: #f11;
  text-decoration: none;
  font-style: normal;
}
.dynamic {
  color: #f11;
  text-decoration: none;
  font-style: normal;
}
.lawitems {
  background: #fff;
}
.lawitems .law-item {
  padding: 21px 0;
  border-bottom: 10px solid #f5f5f5;
}
.lawitems .article-title {
  font-size: 19px;
  padding: 0 17px;
  color: #222;
  font-weight: 700;
  line-height: 30px;
}
.lawitems .nopadding {
  padding-top: 0;
}
.lawitems .article .items {
  margin-top: 8px;
}
.lawitems .article .items .item {
  padding: 0 17px;
  color: #555;
  line-height: 30px;
}
.lawitems .article .items .c-line-clamp2 {
  margin-bottom: 0;
}
.lawitems .lawitems-tip {
  background: #f5f5f5;
  color: #999;
  height: 54px;
  line-height: 44px;
  text-align: center;
}
.lawitems .decs {
  padding: 0 17px;
  margin-top: 4px;
  color: #999;
  vertical-align: middle;
}
.lawitems .decs .time {
  vertical-align: middle;
  margin-right: 6px;
  line-height: 26px;
}
.lawitems .decs .tag {
  border-radius: 8px;
  color: #39b362;
  background: rgba(57, 179, 98, 0.1);
  border: 1px solid rgba(57, 179, 98, 0.5);
  font-size: 10px;
  padding: 0 5px;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.4;
  height: 1.5em;
  box-sizing: border-box;
  display: inline-block;
}
.lawitems .decs .modified-valid {
  color: #3b92f1;
  background: rgba(59, 146, 241, 0.1);
  border: 1px solid rgba(59, 146, 241, 0.5);
}
.lawitems .decs .amendment-valid {
  color: #4e6ef2;
  background: rgba(78, 110, 242, 0.1);
  border: 1px solid rgba(78, 110, 242, 0.5);
}
.lawitems .decs .partial-invalid {
  color: #f7534f;
  background: rgba(247, 83, 79, 0.1);
  border: 1px solid rgba(247, 83, 79, 0.5);
}
.lawitems .decs .invalid {
  color: #858585;
  background: rgba(133, 133, 133, 0.06);
  border: 1px solid rgba(133, 133, 133, 0.5);
}

</style>
